<template>
  <div :class="['p-4', languagesCount >= 4 ? 'hidden' : 'block']">
    <div class="flex justify-between">
      <h1
        class="text-center mb-4 ml-2 text-product-gray font-bold text-2xl justify-center"
      >
        {{ lang["languageSettings"][this.language] }}
      </h1>
      <button class="inline-flex"
      @click="hide()"
      >
        <IconCancel
          fill="none"
          :stroke="languageModalDestructiveIconColor"
          :backgroundColor="languageModalDestructiveBackgroundColor"
        />
      </button>
    </div>
    <div
      class="border-1.5 rounded-xl text-product-gray font-semibold cursor-pointer text-xl"
    >
      <div
        v-if="menu.hasNL || menu.language == 'nl'"
        class="border-b-1.5 p-6 flex"
        @click="
          updateLanguage('nl');
          hide();
        "
      >
        <img class="w-6 h-6 mr-4" src="../assets/images/flags/nether.png" />
        <p>Nederlands</p>
      </div>
      <div
        v-if="menu.hasEN || menu.language == 'en'"
        class="border-b-1.5 p-6 flex"
        @click="
          updateLanguage('en');
          hide();
        "
      >
        <img class="w-6 h-6 mr-4" src="../assets/images/flags/engels.png" />
        <p>English</p>
      </div>
      <div
        v-if="menu.hasFR || menu.language == 'fr'"
        class="border-b-1.5 p-6 flex"
        @click="
          updateLanguage('fr');
          hide();
        "
      >
        <img class="w-6 h-6 mr-4" src="../assets/images/flags/france.png" />
        <p>Français</p>
      </div>
      <div
        v-if="menu.hasDE || menu.language == 'de'"
        class="border-b-1.5 p-6 flex"
        @click="
          updateLanguage('de');
          hide();
        "
      >
        <img class="w-6 h-6 mr-4" src="../assets/images/flags/germany.png" />
        <p>Deutsch</p>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import lang from "../lang";
import IconCancel from "../components/icons/iconCancel.vue";
export default {
  name: "LanguageView",
    components: { IconCancel },
    data() {
        return { lang: lang };
    },
  computed: {
    ...mapGetters(["language", "menu", "languagesCount"]),
    ...mapGetters("Theme", ["languageModalDestructiveBackgroundColor",
      "languageModalDestructiveIconColor"]),
    },
    methods: {
        /**
         * Change the language.
         *
         * @param language String
         *
         * @returns void
         */
        // change the value in the store
        changeLanguage(event) {
            this.$store.commit("changeLanguage", event.target.value);
        },
        // update the language for kiosk
        updateLanguage(language) {
            let currentKioskMode = localStorage.getItem("kioskOption");
            if (currentKioskMode == lang["take_away"][this.language]) {
                this.$store.commit("changeLanguage", language);
                localStorage.setItem("kioskOption", lang["take_away"][this.language]);
            }
            else {
                this.$store.commit("changeLanguage", language);
                localStorage.setItem("kioskOption", lang["dine_in"][this.language]);
            }
        },
        hide() {
            this.$modal.hide("languages");
        },
    }
};
</script>

<style scoped>
.test .flex:last-child {
  border-bottom: none;
}
</style>
